// extracted by css-extract-rspack-plugin
module.exports =  {"loaderwrapper":"L_Au1","black":"oUyea","loading_spinner":"SptED","spin":"dkME7"};